// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { RegistrarService } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Registrar';
import { ERR_ACC_BURN, SUC_ACC_BURN } from '../../../../utils/strings';

export const useAcceptBurnRequest3Step = () => {
  const { submit } = useExerciseSubmission(
    RegistrarService.RegistrarService_AcceptBurnRequest,
    SUC_ACC_BURN,
    ERR_ACC_BURN,
  );
  return submit;
};
